import React from 'react'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, Input } from '@shopflo/ui'
import { CaretDown } from '@phosphor-icons/react'
import { getValueInRange } from 'src/lib/utils/helpers'
import { FlowErrorType } from 'src/lib/types/common/error'
import { rtoRiskDropdownOptions } from 'src/assets/CustomerConditionsConfig'
import { RtoRiskStrategyOptions } from 'src/lib/types/common/customerConditions'
import FormErrorText from 'src/components/common/FormErrorText'

import { CustomerEligibilityOptions, CustomerEligibilityStateType } from 'src/lib/types/common/customerConditions'

interface RtoRiskProps {
  state: Extract<
    CustomerEligibilityStateType,
    { type: CustomerEligibilityOptions.PINCODE_RTO_RISK | CustomerEligibilityOptions.CUSTOMER_RTO_RISK }
  >
  onChange: (value: CustomerEligibilityStateType) => void
  error?: FlowErrorType
}

const RtoRisk: React.FC<RtoRiskProps> = ({ state, onChange, error }) => {
  const { strategy, score } = state
  return (
    <div className='flex flex-col space-y-2 pb-2'>
      <div className='w-full'>
        <div className='flex flex-row w-full gap-3 items-center justify-start min-w-[28rem]'>
          <div className='w-3/5'>
            <Select
              value={strategy}
              onValueChange={val => onChange({ ...state, strategy: val as RtoRiskStrategyOptions })}
            >
              <SelectTrigger className='w-full h-9 rounded-lg'>
                <div className='flex items-center justify-between w-full'>
                  <SelectValue />
                </div>
              </SelectTrigger>
              <SelectContent align='start' className='w-full'>
                {rtoRiskDropdownOptions.map(option => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className='w-2/5 max-w-[5rem]'>
            <Input
              id='rto-risk-score-input'
              value={score}
              onChange={e => {
                const value = getValueInRange(e.target.value, 100, 1, true)
                onChange({ ...state, score: value })
              }}
              type='number'
              dimension='md'
              variant='filled'
              error={error?.status}
            />
          </div>
        </div>
        <FormErrorText message={error?.status ? error.message : ''} />
      </div>
    </div>
  )
}

export default RtoRisk
